/** Summarize the Reolink list API payload for the Alerts status line. */

const videoText = (video) =>
  `${video?.fileName || ''} ${video?.s3Key || ''}`;

const stampFromName = (name) => {
  const match = String(name || '').match(/(\d{8})(\d{6})/);
  return match ? match[1] : '';
};

export const summarizeReolinkReceive = (videos, raw) => {
  const list = Array.isArray(videos) ? videos : [];
  const names = list.map((video) => video?.fileName || video?.s3Key || '').filter(Boolean);
  const stamps = names.map(stampFromName).filter(Boolean).sort();
  const newestStamp = stamps[stamps.length - 1] || '';
  const blob = list.map(videoText).join(' ');
  return {
    apiCount: Number(raw?.count) || list.length,
    received: list.length,
    newestStamp,
    has18Aug: blob.includes('20260818'),
    has17Aug: blob.includes('20260817'),
    hasDestin1: /destin1/i.test(blob),
  };
};
